export enum ERouterName {
    ELEMENT = 'element',
    PROJECT = 'project',
    HOME = 'home',
    TSA = 'tsa',
    LAYER = 'layer',
    MEDIA = 'media',
    WAYLINE = 'wayline',
    LIVESTREAM = 'livestream',
    LIVING = 'living',
    WORKSPACE = 'workspace',
    MEMBERS = 'members',
    DEVICES = 'devices',
    TASK = 'task',
    CREATE_PLAN = 'create-plan',
    SELECT_PLAN = 'select-plan',
    FIRMWARES = 'firmwares',
    ALARM_SCENE = 'alarm-scene',
    FLIGHT_HISTORY = 'flight-history',
    FLIGHT_STATISTICS = 'flight-statistics',
    ELECTRONIC_FENCE = 'electronic-fence',
    FREE_LOGIN = 'free_login',
    FLIGHT_POINT = 'flight_point',
    FLIGHT_REPLAY = 'flight_replay',
    Annotation_Management = 'annotation_management',
    LARGE_SCREEN = 'large_screen',
    VIDEO_T = 'video-t2',
    NEW_HOME = 'new_home',
    MANAGE_DEVICE = 'manage_device',
    MANAGE_MENU = 'manage_menu',
    MANAGE_REGION = 'manage_region',
    MANAGE_ROLE = 'manage_role',

    PILOT = 'pilot-login',
    PILOT_HOME = 'pilot-home',
    PILOT_MEDIA = 'pilot-media',
    PILOT_LIVESHARE = 'pilot-liveshare',
    PILOT_BIND = 'pilot-bind',

    LIVESTREAM_NEW = 'livestream-new',
    ALGORITHM_MODEL = 'algorithm_model'
}

export enum EStorageKey {
    LANG_CODE = 'DJI_CREATE_VITE_H5_APP:lang_code',
    TEST_TOOLS_POSITION_STORAGE_KEY = 'DJI_CREATE_VITE_H5_APP:test_tools_position',
    SESSION_ID = 'DJI_CREATE_VITE_H5_APP:sess'
}

export enum EStatusValue {
    CONNECTED = '已连接',
    DISCONNECT = '未连接',
    LIVING = '直播中'
}

export enum ELiveStatusValue {
    DISCONNECT,
    CONNECTED,
    LIVING
}

export enum EComponentName {
    Thing = 'thing',
    Liveshare = 'liveshare',
    Api = 'api',
    Ws = 'ws',
    Map = 'map',
    Tsa = 'tsa',
    Media = 'media',
    Mission = 'mission'
}

export enum ELocalStorageKey {
    Username = 'username',
    WorkspaceId = 'workspace_id',
    Token = 'x-auth-token',
    PlatformName = 'platform_name',
    PilotOrganizationPlatformTitle = 'pilot_organization_platform_title',
    WorkspaceName = 'workspace_name',
    WorkspaceDesc = 'workspace_desc',
    Flag = 'flag',
    UserId = 'user_id',
    Device = 'device',
    GatewayOnline = 'gateway_online',
    Password = 'password',
    LoginName = 'login_name',
    CarryingList = 'carrying_list',
    LongLat = 'long_lat',
    LargeScreen = 'large_screen',
    RegionCode = 'region_code',
    RoleId = 'role_id',
    MenuList = 'menu_list',
    RoleKey = 'role_key',
    HomeConfig = 'home_config',
    DroneLiveUrl = 'drone_live_url',
    DockLiveUrl = 'dock_live_url',
    PilotAutoUploadPhoto = 'pilot_auto_upload_photo',
    PilotUploadPhotoType = 'pilot_upload_photo_type',
    PilotAutoUploadVideo = 'pilot_auto_upload_video',
    PilotDownloadOwner = 'pilot_download_owner',
    CameraObj = 'camera_obj'

}

export enum EPhotoType {
    Original = 0,
    Preview = 1,
    Unknown = -1
}

export enum EDownloadOwner {
    Mine = 0,
    Others = 1,
    Unknown = -1
}

export enum EUserType {
    Web = 1,
    Pilot = 2,
}

export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    AircraftDetailState = 'aircraft_detail_state',
    DockOsd = 'dock_osd',
    VendorxDeviceOsd = 'vendorx_device_osd', // 遥测数据（GPS定位数据）
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',
    // 图片对比进度
    ImageDiffProgress = 'imageDiffProgress',
    // 喊话
    SpeakerPsdk = 'psdk_floating_window_text',
    SpeakerAudio = 'speaker_audio_play_start_progress',
    SyncWayline='sync_wayline',

    // 机场任务
    FlightTaskProgress = 'flighttask_progress', // 机场任务执行进度
    FlightTaskMediaProgress = 'file_upload_callback', // 机场任务媒体上传进度
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // 机场任务媒体优先级上报
    FlylineAlgTaskStaus = 'Flyline_Alg_Task_Staus',

    // 设备指令
    DeviceReboot = 'device_reboot', // 机场重启
    DroneOpen = 'drone_open', // 飞行器开机
    DroneClose = 'drone_close', // 飞行器关机
    DeviceFormat = 'device_format', // 机场数据格式化
    DroneFormat = 'drone_format', // 飞行器数据格式化
    CoverOpen = 'cover_open', // 打开舱盖
    CoverClose = 'cover_close', // 关闭舱盖
    PutterOpen = 'putter_open', // 推杆展开
    PutterClose = 'putter_close', // 推杆闭合
    ChargeOpen = 'charge_open', // 打开充电
    ChargeClose = 'charge_close', // 关闭充电

    // 设备升级
    DeviceUpgrade = 'ota_progress', // 设备升级

    // 设备日志
    DeviceLogUploadProgress = 'fileupload_progress', // 设备日志上传

    // 飞行指令消息
    ControlSourceChange = 'control_source_change', // 控制权更新
    FlyToPointProgress = 'fly_to_point_progress', // 飞向目标点
    TakeoffToPointProgress = 'takeoff_to_point_progress', // 一键起飞
    JoystickInvalidNotify = 'joystick_invalid_notify', // 设备端退出drc模式
    DrcStatusNotify = 'drc_status_notify', // 飞行控制模式状态
    InFlightWaylineProgress = 'in_flight_wayline_progress',
    ReturnHomeInfo = 'return_home_info', // 设备规划的返航路径
}

export enum EDeviceTypeName {
    Aircraft = 0,
    Gateway = 2,
    Dock = 3,
    FixedWing = 4, // 固定翼
    FixedWing2 = 1, // 固定翼
    StreamDevice = 5, // 推流设备
    DetectionDevice = 6, // 监视设备（前端分类，不作为大疆设备 domain）
}

export enum EHmsLevel {
    NOTICE,
    CAUTION,
    WARN,
}
// 飞机机型

export const AircraftTypeOptions = [
  { type: 67, label: 'Matrice 30T', sub_type: 1, payload_type: 53, payload_sub_type: 0, gimbalindex: 0 },
  { type: 91, label: 'Matrice 3TD', sub_type: 1, payload_type: 81, payload_sub_type: 0, gimbalindex: 0 },
  { type: 100, label: 'Matrice 4TD', sub_type: 1, payload_type: 99, payload_sub_type: 0, gimbalindex: 0 },

]
